'use strict';
var moment = require('moment');

module.exports = {
    isValidIdStr: function(value, options, key, attributes) {
        let date;
        const idStr = (value || '').replace(/_/g, '');

        if (attributes.idType !== 1) {
            return null;
        }

        if (idStr.replace(/-/g, '').length === 0) {
            return null;
        }

        if (idStr.length < 14) {
            return 'is too short';
        }

        if (parseInt(value.substr(0, 2), 10) > 15) {
            value = '19' + value;
        } else {
            value = '20' + value;
        }

        date = moment(value.substr(0, 8) + '+00:00', 'YYYYMMDDZ')
            .utcOffset(0);
        return date.isValid() ? null : ' is not valid';
    },

    batchPaymentSettings: function(value, options, key, attributes) {
        if (!attributes.bankAccountId) {
            return null;
        }

        if (!attributes.isCreditingDateRequired) {
            return null;
        }

        if (
            !value ||
            typeof value !== 'object' ||
            typeof value.creditingDate === 'undefined'
        ) {
            return 'are not valid. Missing crediting date.';
        }

        return null;
    }
};



// WEBPACK FOOTER //
// ./app/helpers/validators.js